{
  "name": "device-qrcode-provisioning",
  "version": "4.0.0",
  "engines": {
    "node": "^22.22.3 || ^24.18.1"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "lint": "eslint src --fix && npm run format",
    "format": "prettier --write \"src/**/*.{js,jsx,json,md,ts,tsx}\"",
    "e2e": "ng e2e",
    "build:prod": "ng build --configuration=production",
    "build:dev": "ng build --configuration=development",
    "build:inte": "ng build --configuration=integration",
    "build:local": "ng build --configuration=local",
    "deploy:prod": "ng build --configuration=production && bluemix app push -f=manifest-prod.yml",
    "deploy:dev": "ng build --configuration=development && bluemix app push -f=manifest-dev.yml",
    "deploy:inte": "ng build --configuration=integration && bluemix app push -f=manifest-dev.yml",
    "start:local": "ng serve --configuration=local",
    "start:dev": "ng serve --configuration=development",
    "start:inte": "ng serve --configuration=integration",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run",
    "prepare": "npx husky install"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.0",
    "@angular/cdk": "^22.1.0",
    "@angular/common": "^22.1.0",
    "@angular/compiler": "^22.1.0",
    "@angular/core": "^22.1.0",
    "@angular/forms": "^22.1.0",
    "@angular/material": "^22.1.0",
    "@angular/platform-browser": "^22.1.0",
    "@angular/platform-browser-dynamic": "^22.1.0",
    "@angular/router": "^22.1.0",
    "core-js": "^3.26.1",
    "qr-scanner": "^1.4.2",
    "rxjs": "^7.5.7",
    "sass": "^1.56.1",
    "socket.io-client": "^4.8.1",
    "tslib": "^2.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^22.1.2",
    "@angular-eslint/builder": "22.1.0",
    "@angular-eslint/schematics": "22.1.0",
    "@angular/cli": "^22.1.2",
    "@angular/compiler-cli": "^22.1.0",
    "@angular/language-service": "^22.1.0",
    "@cypress/schematic": "^2.3.0",
    "@types/node": "^24",
    "cypress": "15.19.0",
    "eslint": "^9.39.5",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-prettier": "^5.1.3",
    "husky": "^8.0.3",
    "prettier": "^3.3.3",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.65.0"
  },
  "overrides": {
    "cacache": "17.0.2",
    "@modelcontextprotocol/sdk": "^1.30.0"
  }
}
